import { render, staticRenderFns } from "./ResourcesTrainingIntro.vue?vue&type=template&id=0f30b45e&"
import script from "./ResourcesTrainingIntro.vue?vue&type=script&lang=js&"
export * from "./ResourcesTrainingIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports